const useCurrentUser = () => {
  const appState = JSON.parse(localStorage.getItem('appState'));
  const user = appState?.user;

  return {
    user,
    role: user?.role,
    isAdmin: user?.role === 'admin',
  };
};

export default useCurrentUser;
